import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface DeleteCategoryParams {
  id: string
}

const deleteCategory = async ({ id }: DeleteCategoryParams): Promise<void> => {
  await api.delete(`/category/${id}`)
}

export const useDeleteCategory = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, DeleteCategoryParams>({
    mutationFn: deleteCategory,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.categoryDeleted'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['categories'] }),
        queryClient.invalidateQueries({ queryKey: ['category', variables.id] }),
        queryClient.invalidateQueries({ queryKey: ['category-contacts', { id: variables.id }] }),
      ])
    },
  })
}

